var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmarkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkmark--outline_3_",
    "data-name": "checkmark--outline (3)",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21050",
    "data-name": "Path 21050",
    d: "M11.143,15.463,9,13.32l.606-.606,1.537,1.537L14.394,11l.606.606Z",
    transform: "translate(-4 -5.143)",
    fill: "#203662"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21051",
    "data-name": "Path 21051",
    d: "M8,2a6,6,0,1,0,6,6A6,6,0,0,0,8,2ZM8,13.143A5.143,5.143,0,1,1,13.143,8,5.143,5.143,0,0,1,8,13.143Z",
    transform: "translate(0 0)",
    fill: "#203662"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkIcon);
export default __webpack_public_path__ + "static/media/checkmark-icon.c2f031469da127ad98ec777c0b3f0ce3.svg";
export { ForwardRef as ReactComponent };